<template>
  <section>
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <!-- <el-button type="primary" @click="division_add()">新增</el-button> -->
    <el-form  class="form_cls" :inline="true" v-if="buttonList != null && buttonList.length > 0" :model="filters" @submit.native.prevent>
      <el-form-item label="">
        <el-input v-model="filters.name" placeholder="请输入"></el-input>
      </el-form-item>
      
      <!-- <el-form-item label="医院编码">
        <el-input v-model="filters.bwacctnumber" placeholder="医院编码"></el-input>
      </el-form-item> -->
      <!-- 这个就是当前页面内，所有的btn列表 -->
      <el-form-item v-for="item in buttonList" v-bind:key="item.id">
        <!-- 这里触发点击事件 -->
        <el-button :type="
						item.Func &&
						(item.Func.toLowerCase().indexOf('handledel') != -1 ||
							item.Func.toLowerCase().indexOf('stop') != -1)
							? 'danger'
							: 'primary'
					" v-if="!item.IsHide" @click="callFunc(item)">{{ item.name }}</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div class="table_top_div">
        <div>
    <el-table :max-height="tableHeight" :data="users" :header-cell-style="{'text-align':'center','color':'#6170d7','backgroundColor':'#F5F7FA'}" :cell-style="{'text-align':'center'}" highlight-current-row @current-change="selectCurrentRow" v-loading="listLoading" @selection-change="selsChange"   >
      <!-- <el-table-column sortable type="selection" width="50">
      </el-table-column>-->
      <el-table-column type="index" width="80">
        <template slot="header" slot-scope="{}">
          <span style="padding: 8px 0">序号 
           <span class="caret-wrapper" style="width:0px"></span>
            </span>
          <!-- <span class="caret-wrapper" style="padding-top: 0px"></span> -->
        </template>
      </el-table-column>
      <el-table-column sortable prop="Remark" label="备注" width=""></el-table-column>
      <el-table-column sortable prop="Name" label="姓名" width=""></el-table-column>
      <el-table-column sortable prop="Type" label="审批类型" width=""></el-table-column>
      <el-table-column sortable prop="ID" label="id" width=""></el-table-column>
      <el-table-column sortable prop="CreateTime" label="创建时间" width=""></el-table-column>
      <el-table-column sortable prop="ModifyTime" label="修改时间" width=""></el-table-column>
      <el-table-column sortable prop="IsDeleted" label="是否删除" width=""></el-table-column>
      <el-table-column sortable prop="CreatorID" label="创建者id" width=""></el-table-column>
      <el-table-column sortable prop="ModifyID" label="修改人id" width=""></el-table-column>
      <el-table-column label="操作" width="160">
        <template slot="header" slot-scope="{}">
          <span style="padding: 8px 0">操作 
           <span class="caret-wrapper" style="width:0px"></span>
            </span>
        </template>
        <template scope="scope">
          <!-- <el-link type="primary" @click="handledetails(scope.row)">
            详情
          </el-link>
          | -->
          <el-link type="primary" @click="handleEdit(scope.row)">
            <i class="el-icon-setting"></i>设置
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    </div>
  
    <!--工具条-->
    <div class="toolbar_div">
        <el-col :span="24" class="toolbar">
        <!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
         <el-pagination :background='true' layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="50" :total="total" style="float: right"></el-pagination>
        </el-col>
    </div>
    </div>
      <el-dialog title="设置" :visible.sync="dialogVisible" width="40%" :before-close="handleClose">
      <el-row>
        <el-button type="primary" @click="node_add()">添加节点</el-button>
        <el-row v-for="(node_item, node_index) in node_list" style="margin-top: 10px">
          <!-- <el-button type="success" icon="el-icon-check" circle></el-button> -->
          <el-form>
            <el-form-item>
                <span style="height: 20px;width: 20px;display: inline-block;background: #67c23a;text-align: center;border-radius: 50%;color: white;margin-right: 10px;line-height: 20px;">{{node_index+1}}</span>
          <el-select style="width:30%" v-model="node_item.FlowExec" filterable placeholder="请选择">
            <el-option v-for="item in options_str" :key="item.FlowExec" :label="item.OptionName" :value="item.FlowExec">
            </el-option>
          </el-select>
          <el-select style="width:30%" v-if="node_item.FlowExec == 1" v-model="node_item.FlowExecID" filterable placeholder="请选择">
            <el-option v-for="items in options_str2" :key="items.Id" :label="items.Name" :value="items.Id">
            </el-option>
          </el-select>
          <el-select style="width:30%" v-if="node_item.FlowExec== 2" v-model="node_item.FlowExecID" filterable :filter-method="options_str3_change" placeholder="请选择">
            <el-option v-for="items in options_str3" :key="items.ID" :label="items.Name" :value="items.ID">
            </el-option>
          </el-select>
          <el-button v-if="node_index + 1 == node_list.length" type="danger" @click="delete_node(node_index)" style="margin-left: 10px">删除节点</el-button>
            </el-form-item>
          </el-form>
        </el-row>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="Closes">取 消</el-button>
        <el-button type="primary" @click="submit_node()">确 定</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import util from '../../../util/date';
import { Flow_GetPage ,Flow_GetFlowDataInfoByID , Flow_GetFlowSelectOptions,FlowUpdateFlowInfo,getRoleListPage,Employee_GetList} from '../../api/api';
import { getButtonList } from '../../promissionRouter';
import Toolbar from '../../components/Toolbar';

export default {
  components: { Toolbar },
  data () {
    return {
         tableHeight:0,
      node_list: [],
      options_str: [],
      options_str2: [],
      options_str3:[],
      value: '',
      dialogVisible: false,
      SalesOperation_if: false,
      edit_if_2: false,
      edit_if: true,
      buttonList: [],
      managercode_list: [],
      currentRow: null,
      filters: {
        pageSize: 50,
      },
      users: [],
      statusList: [
        { LinkUrl: '激活', value: true },
        { LinkUrl: '禁用', value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      list_flow:{
            ID:1,
            list:[]
        }
    };
  },
  methods: {
    delete_node (e) {
      this.node_list.splice(e, 1);
    },
    // options_str3_change
    options_str3_change(e){
      console.log(e)
      this.Employee_GetList_fn(e)
    },  
    async Employee_GetList_fn(e){
        const {data} =await Employee_GetList({
            code:e
        })
      this.options_str3 = data.response
    },
    async Flow_GetFlowSelectOptions_dn(){
      const {data} =await Flow_GetFlowSelectOptions()
      this.options_str = data.response
      console.log(data)
    },
    async getRoleListPage_fn(){
        const {data} =await getRoleListPage()
      this.options_str2 = data.response.data
    },
    //编辑
    handleEdit: async function (res) {
        this.list_flow={ID:1,list:[]}
        this.Flow_GetFlowSelectOptions_dn()
        this.getRoleListPage_fn()
        this.Employee_GetList_fn()
      this.dialogVisible = true;
      const {data} =await Flow_GetFlowDataInfoByID({
        id:res.ID
      })
      this.list_flow.ID = res.ID
      this.node_list = data.response
    },
    Closes () {
      this.dialogVisible = false;
      this.node_list = [];
    },
    handleClose (done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          this.node_list = [];
          done();
        })
        .catch((_) => { });
    },
  async  submit_node () {
        this.list_flow.list = this.node_list
        const {data} = await FlowUpdateFlowInfo(this.list_flow)
        if (data.success){
          this.$message({
            message:data.msg,
            type: 'success',
          });
          this.dialogVisible = false
          this.getModules();
        } else{
          this.$message({
            message: res.data.msg,
            type: 'error',
          });
        }
    },
    node_add () {
        console.log(555)
      let list = this.node_list;
      if (list.some((item) => Object.keys(item).length ==0 ))
      {
        this.$message({
          message: '请完善已添加的节点，再进行添加',
          type: 'error',
        });
        return;
      }
      this.node_list.push({});
    },
    ExportAccount () {
      let para = this.filters;
      member_overrun_ExportExcel(para).then((res) => {
        window.location.href = res.data.msg;
      });
    },
    selectCurrentRow (val) {
      this.currentRow = val;
    },
    callFunc (item) {
      this[item.Func].apply(this, item);
    },
    // 导出
    // ExportAccount() {
    //   // let para = this.filters
    //   let para = {};
    //   //  para.account_manager = para.account_manager.toString()
    //   //  window.open("​/api​/store_data​/ExportStore?")
    //   store_data_ExportStore(para).then((res) => {
    //     //window.open("http://47.103.87.196:8082" + res.data.msg);
    //     window.location.href = res.data.msg;
    //   });
    // },
    //性别显示转换
    formatEnabled: function (row, column) {
      return row.Enabled ? '正常' : '未知';
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ''
        ? ''
        : util.formatDate.format(
          new Date(row.CreateTime),
          'yyyy-MM-dd'
        );
    },
    handleCurrentChange (val) {
      this.page = val;
      this.getModules();
    },
    getModules_search () {
      this.page = 1;
      this.getModules();
    },
    //获取用户列表
    getModules () {
      let para = this.filters;
      para.page = this.page;
      console.log(para);
      // return
      //   let para = {
      //     page: this.page,
      //     key: this.filters.key
      //   };
      this.listLoading = true;
      Flow_GetPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
      });
    },
    //删除
    handleDel (ids) {
      console.log(ids);
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning',
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: ids };
          channel_Delete(para).then((res) => {
            if (util.isEmt.format(res))
            {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success)
            {
              this.$message({
                message: '删除成功',
                type: 'success',
              });
            } else
            {
              this.$message({
                message: res.data.msg,
                type: 'error',
              });
            }

            this.getModules();
          });
        })
        .catch(() => { });
    },
    handleWithdraw (id) {
      // 撤回
      store_data_Reback_Store('store_id=' + id).then((res) => {
        if (res.data.success)
        {
          this.$message({
            message: '撤回成功',
            type: 'success',
          });
          this.getModules();
        } else
        {
          this.$message({
            message: res.data.msg,
            type: 'error',
          });
        }
      });
    },
    handledetails: function (e) {
      // this.details_tag('我的门店2')
      this.$router.push({
        path: '/HCO/HCO_details',
        query: {
          id: e.ID,
          approval_data_id: e.approval_data_id,
          type: 'CK',
          back_url: '/HCO/HCO_list',
        },
      });
    },
    handleAdd () {
      this.dialogVisible = true;
    },

    handledetails_SalesOperation: function (
      ids,
      progress,
      outletnumber__c
    ) {
      // this.details_tag('我的门店2')
      this.$router.push({
        path: '/StoreManage/add_store',
        query: {
          id: ids,
          type: 'store_ck',
          progress: progress,
          approval_type: 'store',
          outletnumber__c: outletnumber__c,
          list_SalesOperation: 1,
        },
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //localStorage 存储数组对象的方法
    saveObjArr (name, data) {
      localStorage.setItem(name, JSON.stringify(data));
    },

    //localStorage 获取数组对象的方法
    getObjArr (name) {
      return JSON.parse(window.localStorage.getItem(name));
    },
    details_tag (name) {
      var router_list = this.getObjArr('router');
      for (let i in router_list)
      {
        for (let s in router_list[i].children)
        {
          //  console.log(999)
          if (router_list[i].children[s].id == '175')
          {
            //  console.log(999)
            router_list[i].children[s].name = name;
            router_list[i].children[s].meta.title = name;
            console.log(router_list[i].children[s].name);
            this.saveObjArr('router', router_list);
            console.log(this.getObjArr('router'));
          }
        }
      }
      //  this.getObjArr('router') = router_list
      console.log(router_list);
    },
  },
  mounted () {
     this.$nextTick(()=>{
        	      this.tableHeight = window.innerHeight - 250;
		})
    console.log(this.getObjArr('router'));
    this.getModules();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
 /* .el-select,
 .el-date-editor,.el-cascader {
  width: 100% !important
} */
</style>

